import '../common/base';
import Vue from './../vue/common/vue-common';
import SchoolMakeover from '../vue/components/school/SchoolMakeover';
import { getSimpleVueHorizontalScroll } from '../vue/horizontal-scroll';

// elements
let campaignFeatureEl,
    campaignFeatureGapEl,
    campaignFeatureIcon,
    campaignFeatureTexts,
    previousAfterEl,
    previousAfterBtn,
    mapArtAnimationEl;

const initEls = () => {
    if (campaignFeatureGapEl) return;

    campaignFeatureEl = document.getElementById('campaign-feature');
    campaignFeatureGapEl = document.getElementById('campaign-feature-gap');
    campaignFeatureIcon = document.getElementsByClassName('mouse-scroll-hint')[0];
    campaignFeatureTexts = campaignFeatureEl.querySelectorAll('p');
    previousAfterEl = document.getElementById('campaign-previous-after');
    previousAfterBtn = document.getElementById('campaign-previous-after-btn');
    mapArtAnimationEl = document.getElementById('campaign-about-animation');
};

const scrollFeature = (scroll) => {
    const gap =
        campaignFeatureGapEl.offsetTop +
        campaignFeatureGapEl.offsetHeight -
        campaignFeatureEl.offsetHeight;
    const percent = Math.min(1, scroll / gap);

    if (percent === 1) {
        campaignFeatureEl.classList.add('campaign-feature-relative');
        campaignFeatureTexts[campaignFeatureTexts.length - 1].classList.remove('show-scroll-hint');
    } else {
        campaignFeatureEl.classList.remove('campaign-feature-relative');

        if (scroll > 0) {
            campaignFeatureIcon.style.opacity = 0;
        } else {
            campaignFeatureIcon.style.opacity = 1;
        }

        for (let i = 0; i < campaignFeatureTexts.length; i++) {
            if (i / campaignFeatureTexts.length < percent) {
                if (campaignFeatureTexts[i].style.opacity == 0) {
                    campaignFeatureTexts[i].style.opacity = 1;
                    if (i > 0) campaignFeatureTexts[i - 1].classList.remove('show-scroll-hint');
                    campaignFeatureTexts[i].classList.add('show-scroll-hint');
                }
            } else {
                campaignFeatureTexts[i].style.opacity = 0;
                if (i > 0) campaignFeatureTexts[i - 1].classList.add('show-scroll-hint');
            }
        }
    }
};
const onScroll = () => {
    initEls();

    const scroll = document.body.scrollTop || document.documentElement.scrollTop;

    scrollFeature(scroll);
};

window.addEventListener('scroll', onScroll, { passive: true });

onScroll();

new Vue(SchoolMakeover);

const horizontalScrollEl = cr$.byId('school-slider');
if (horizontalScrollEl) {
    requestIdleCallback(() => {
        getSimpleVueHorizontalScroll(horizontalScrollEl.raw, true);
    });
}
